import * as React from 'react';

interface IOfferHistoryProps {
  fullscreenViewBtn?: React.ReactElement;
  fullscreenView: React.ReactElement;
  offersTableSmall: React.ReactElement;
  tabs?: React.ReactElement;
}

export const OfferHistoryNew: React.FC<React.PropsWithChildren<IOfferHistoryProps>> = ({
  offersTableSmall,
  fullscreenViewBtn,
  fullscreenView,
  tabs,
}) => {
  return (
    <>
      {tabs}
      {offersTableSmall}
      {fullscreenViewBtn}
      {fullscreenView}
    </>
  );
};
